import React from 'react'
import { Button } from '@/Components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '@/Components/ui/dialog'
import { Input } from '@/Components/ui/input'
import { Label } from '@/Components/ui/label'
import SearchableDropdown from './SearchableDropdown'
const AssignmentPopup = ({ type, open, setOpen }) => {
    console.log('open', open)
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="sm:max-w-[425px]" aria-describedby="assign-employee">
                <DialogHeader>
                    <DialogTitle>{type} To</DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <div className="grid  items-center gap-2">
                        <Label htmlFor="name">Roles</Label>
                        <SearchableDropdown options={[]} />
                    </div>
                    <div className="grid  items-center gap-4">
                        <Label htmlFor="username">Username</Label>
                        <SearchableDropdown options={[]} className="text-left" />
                    </div>
                </div>
                <DialogFooter>
                    <Button type="submit">{type}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default AssignmentPopup
